module.exports = __webpack_public_path__ + "54960f5117bd7f6ec36b197c6669600d.ico";